import { HamburgerSvg, UserFillRoundSvg } from '../../assets/svgs';
import UserAvatarActionComponent from '../user-avatar-action';
// import SwitchComponent from '../switch';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMenu } from '../../redux/slices/menu-click-slice';
// import { useDarkMode, useFullScreen } from '../../hooks';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { getLogoutUser } from '../../redux/slices/auth-slice';
import { ActionsWrapper, HeaderWrapper, LogoWrapper, MenuWrapper } from './header.style';

const HeaderComponent = ({
    logo = {
        src: '/logo.webp',
        alt: 'Open ACS',
    },
    removeThemeSwitch,
    removeFullscreen,
    removeAvatar,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);

    // const [isDarkMode, toggleDarkMode] = useDarkMode();
    // const [isFullScreen, toggleFullScreen] = useFullScreen();

    const handleMenuClick = () => {
        dispatch(toggleMenu());
    };

    const userActions = [
        { label: 'Change Password', action: () => navigate('/user-operations/changepassword') },
        { label: 'Signout', action: () => dispatch(getLogoutUser()) },
    ];

    return (
        <HeaderWrapper className='box-shadow'>
            {/* MENU BUTTON */}
            <MenuWrapper>
                <div className="menu-container">
                    <HamburgerSvg onClick={handleMenuClick} />
                </div>
            </MenuWrapper>

            {/* LOGO */}
            <LogoWrapper>
                <img src={logo?.src} alt={logo?.alt} />
            </LogoWrapper>

            {/* ACTIONS */}
            <ActionsWrapper>
                {/* THEME SWITCH */}
                {/* {
                    !removeThemeSwitch &&
                    <SwitchComponent size="small" value={isDarkMode} handleChange={toggleDarkMode} />
                } */}

                {/* FULLSCREEN TOGGLE */}
                {/* {
                    !removeFullscreen && (
                        <FullScreenButton onClick={toggleFullScreen}>
                            {isFullScreen ? <ShrinkSvg /> : <ExpandSvg />}
                        </FullScreenButton>
                    )
                } */}

                {/* USER */}
                {
                    !removeAvatar &&
                    <UserAvatarActionComponent
                        icon={UserFillRoundSvg}
                        // name={`<b>${user?.name}</b>` + (user?.lastLoginDateTime ? `, Last Login: ${user?.lastLoginDateTime}` : null)}
                        name={
                            <>
                                <b>{user?.name}</b>
                                {user?.lastLoginDateTime && `, Last Login: ${user?.lastLoginDateTime}`}
                            </>
                        }
                        userActions={userActions}
                        mui
                    />
                }
            </ActionsWrapper>
        </HeaderWrapper>
    );
};

HeaderComponent.propTypes = {
    logo: PropTypes.object.isRequired,
    removeThemeSwitch: PropTypes.bool,
    removeFullscreen: PropTypes.bool,
    removeAvatar: PropTypes.bool,
};

export default HeaderComponent;
